import React from 'react';
import './wordpinyin.css';
const WordPinyin = ({ pinyin, showDetailAndSelect }) => {
  return <div className="pinyin">{showDetailAndSelect && pinyin}</div>;
};
export default WordPinyin;
